import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "c9f38f29-1f3c-4a1f-a3ed-aed1c425c766", content: "Is easier to tune.", options: {} },
  { id: "9393cb5a-e8a9-4a1f-aec0-02b951004267", content: "Does not suffer from<br>aeroacoustical noise.", options: {} },
  {
    id: "e46d3a1e-f569-401f-ada1-b8d915da581b",
    content: "Can be used with smaller<br>enclosure volumes.",
    options: {},
  },
  {
    id: "801632dc-588f-4c3d-8f27-9af1f1e0a750",
    content: "Reduces the transmission of the<br>box standing waves.",
    options: {},
  },
  {
    id: "de9404a4-dbcf-4fbc-bc70-44d53276c188",
    content: "Can provide 10 times lower<br>cut-off frequency.",
    options: {},
  },
  {
    id: "f275a4c0-f00a-471f-960d-6f5c962c2600",
    content: "Has a better efficiency for f>10f<sub>s</sub>.",
    options: {},
  },
];

export const task: Task = {
  id: "6635d14d-3954-4fad-aaf7-5c2324ba0b84",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "9393cb5a-e8a9-4a1f-aec0-02b951004267",
    "e46d3a1e-f569-401f-ada1-b8d915da581b",
    "801632dc-588f-4c3d-8f27-9af1f1e0a750",
  ],
};
